import { Skeleton, Stack } from '@mui/joy'
import { useGate, useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
  editMassMailingModel,
  DeleteMassMailing,
} from '~/features/MassMailing/EditMassMailing'
import { EditMassMailing } from '~/features/MassMailing/EditMassMailing/EditMassMailing'
import { $massMailing } from '~/features/MassMailing/EditMassMailing/model'
import { massMailingModel } from '~/entities/MassMailing'
import { massMailingStatusLabels } from '~/shared/config/constants'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { ChipStatus } from '~/shared/ui/Chips'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

export const EditMassMailingPage = () => {
  const { massMailingId } = useParams<{ massMailingId: string }>()
  useGate(massMailingModel.Gate, { massMailingId: massMailingId as string })

  const isLoading = useStore(massMailingModel.requestFx.pending)
  const massMailingTitle = useStoreMap(
    editMassMailingModel.$massMailing,
    (massMailing) => massMailing?.getName(),
  )
  const massMailing = useStore($massMailing)
  const massMailingStatus = massMailing?.getStatus()

  const chipLabel = massMailingStatus
    ? massMailingStatusLabels[massMailingStatus]
    : ''
  const chipVariant = massMailingStatus
    ? massMailing?.getStatusVariant(massMailingStatus)
    : 'gray'

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { title: 'Уведомления', link: '/mass-mailing' },
      { title: massMailingTitle || '' },
    ],
    [massMailingTitle],
  )

  return (
    <PageContainer title='Карточка уведомления'>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <ChipStatus
          data-testid='massMailing-status'
          label={chipLabel}
          variant={chipVariant ?? 'gray'}
          sx={{ minWidth: '70px', marginBottom: '6px' }}
          loading={
            isLoading && (
              <Skeleton
                sx={{
                  top: 0,
                  left: 0,
                  minWidth: '70px',
                }}
              />
            )
          }
        />
        <Stack direction='row' justifyContent='space-between' spacing={2}>
          <PageTitle loading={isLoading}>{massMailingTitle}</PageTitle>
          <DeleteMassMailing />
        </Stack>
      </Container>
      <EditMassMailing massMailingId={massMailingId as string} />
    </PageContainer>
  )
}
